import authServices from "../../../../services/authServices";
import dataProvider from "../../../../services/dataProvider";
import icomplyLogo from "../../../../assets/images/icomply.png";
var axios = require("axios");
var qs = require("qs");

export default async function FrontDeskPdfGenerator(formType, formSchema, formState) {
    let html = `
        <div class="template-container">

        <style>
            .template-container {
                background-color: #fff ;
                margin : 1rem ;
                padding: 1rem ;
                font-family: sans-serif ;
                border-radius: 8px ;
                border : 1px solid #eee ;
            }

            .template-icomply-brand {
                display:flex;
                align-items:center;
                justify-content:center;
                padding: 2rem 0;
            }

            .template-icomply-brand img {
                height : 3rem ;
            }

            .template-self-declaration {
                background-color: #fff ;
                padding: 1rem ;
                font-family: sans-serif ;
                border-radius: 8px ;
                border : 1px solid #eee ;
                margin-top:1.5rem;
            }

            .template-self-declaration h3{
                line-height:1;
            }

            .template-self-declaration p {
                font-size : 14px ;
            }
            
            .template-container .template-name {
                font-size: 1.25rem ;
                font-weight: 700 ;
                line-height:2;
            }
            
            .template-container .template-field {
                flex: 1 ;
                display: flex ;
                line-height: 2.5rem ;
            }

            .template-container .template-link {
                text-align:left;
            }

            .template-tnc {
                display: flex ;
                align-items:center;
            }
            
            .template-container .template-field .template-key ,
            .template-container .template-link .template-key {
                font-weight: 700 ;
                margin-right: 0.5rem ;
            }
            
            .template-container .template-field .template-value ,
            .template-container .template-link .template-value {
                color: #444;
            }
        </style>
        <div class="template-icomply-brand">
            <img src="${icomplyLogo}" />
        </div>
        <div class="template-name">${formSchema.formTitle}</div>
    `;

    // console.log(formType,formState);

    const fields = formSchema.fields;

    for(let key of Object.keys(fields)){
        switch (formSchema.fields[key].type) {
            case "checkbox":
                html += checkboxTemplate(formSchema.fields[key], formState[key]);
                break;
            case "date":
                html += dateTemplate(formSchema.fields[key], formState[key]);
                break;
            case "file":
                html += await fileTemplate(formSchema.fields[key], formState[key]);
                break;
            case "fileOrDate":
                html += await dateOrFileTemplate(formSchema.fields[key], formState, key);
                break;
            case "optionalFile":
                html += await optionalFileTemplate(formSchema.fields[key], formState, key);
                break;
        }
    }

    // self declaration part

    html += `<div class="template-self-declaration">
        <h3>Self Declaration</h3>
        <p>
            You are about to declare that you have met requirements under the Property & Stock Agents Act 2002. This declaration will be used to demonstrate compliance and may be subject to audit review by Fair Trading
        </p>
        <div class="template-tnc">
            <input type="checkbox" checked="${formState.tncAgreed}" />
            <span style="margin-left:0.25rem"> I agree to the Terms of Service</span>
        </div>
        <div class="template-field">
            <div class="template-key">Name Of Person Completing Form</div>
            <div class="template-value">${formState.nameOfPersonCompletingForm}</div>
        </div>
        <div class="template-field">
            <div class="template-key">Date</div>
            <div class="template-value">${formState.dateOfFormCompletionInString}</div>
        </div>
    `

    html += normalTemplate("Name of person completing form",formState.nameOfPersonCompletingForm || "-") ;
    html += normalTemplate("Date",formState.dateOfFormCompletionInString || "-" ) ;

    html += "</div></div>";

    return html;
}


function normalTemplate(label, value) {
    return `
        <div class="template-field">
            <div class="template-key">${label}</div>
            <div class="template-value">${value}</div>
        </div>
    `;
}


function linkTemplate(label, link) {
    return `
        <div class="template-field">
            <div class="template-key">${label}</div>
            <div class="template-value">
                <a href="${link}">View File</a>
            </div>
        </div>
    `;
}

function checkboxTemplate(fieldInfo, value) {
    return `
        <div class="template-field">
            <div class="template-key">${fieldInfo.label}</div>
            <div class="template-value" style="display:flex;align-items:center;">
                <input type="checkbox" checked="${value}" />
            </div>
        </div>
    `;
}

function dateTemplate(fieldInfo, value) {
    let date = new Date(value);
    let formatedDate = value;
    if (date.toString() !== "Invalid Date") {
        formatedDate = `${date.getDate()}/${date.getMonth()}/${date.getFullYear()}`;
    }

    return normalTemplate(fieldInfo.label,formatedDate) ;
}



function fileTemplate(fieldInfo, value) {
    return new Promise((res, rej) => {
        if(!value) res(normalTemplate(fieldInfo.label,"No File Uploaded"));

        var data = qs.stringify({
            filePath: value,
        });
        var config = {
            method: "post",
            url: dataProvider.baseUrl + "getFileUrlForPdf",
            headers: {
                token: authServices.getToken(),
                "Content-Type": "application/x-www-form-urlencoded",
            },
            data: data,
        };

        axios(config)
            .then(function (response) {
                if(response.data.status === "success") {
                    res(linkTemplate(fieldInfo.label,response.data.data[0]));
                } else {
                    res(normalTemplate(fieldInfo.label,"Unable to get file link"));
                }
            })
            .catch(function (error) {
                console.error(error);
                res(normalTemplate(fieldInfo.label,"Unable to get file link"));
            });
    });
}


async function dateOrFileTemplate(fieldInfo, formState,key) {
    if(formState[key + "HasFile"] === "false") {
        return normalTemplate(fieldInfo.question,"NO") + dateTemplate({label:fieldInfo.onNo},formState[key]);
    } else {
        return normalTemplate(fieldInfo.question,"YES") + await fileTemplate({label:fieldInfo.onYes },formState[key]);
    }
}

async function optionalFileTemplate(fieldInfo, formState,key) {
    if(formState[key + "HasFile"] === "false") {
        return normalTemplate(fieldInfo.question,"NO") ;
    } else {
        return normalTemplate(fieldInfo.question,"YES") + await fileTemplate({label:fieldInfo.onYes },formState[key]);
    }
}